import { Component, OnInit, OnDestroy } from '@angular/core';
import {Observable, Subject, tap} from 'rxjs';
import { PortalStateService } from 'src/app/core/services/portal-state.service';
import Icons from 'src/app/core/enums/icons.enum';
import { PortalApp } from 'src/app/core/shared/portal-app';
import { Application } from 'src/portaljs/constants/application';
import { AuthService } from 'src/app/core/services/auth.service';
import * as _ from 'lodash-es';
import {EnvironmentService} from '../../../core/services/environment.service';

@Component({
    selector: 'fss-portal-app-submenu',
    templateUrl: './app-submenu.component.html',
    styleUrls: ['./app-submenu.component.scss'],
    standalone: false
})
export class AppSubmenuComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();
  public icons = Icons;
  public hide: boolean = false;

  public appsByGroup: any;
  public selectableApps$: Observable<PortalApp[]> = this.portalStateService.getSelectableApps$().pipe(
    tap(rez => {
      const appsToRemove: Application[] = [Application.MASTERLIBRARY_SCHEDULES, Application.MASTERLIBRARY_DRAWINGS,
        Application.MASTERLIBRARY_WORKORDERS, Application.MASTERLIBRARY_HELPDESK, Application.MASTERLIBRARY_ITAM];
      return _.remove(rez, (data: PortalApp) => appsToRemove.indexOf(data.app) >= 0);
    }));

  constructor(private portalStateService: PortalStateService, private authService: AuthService, private envService: EnvironmentService) {
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  public ngOnInit() {
    this.hide = false;
  }

  public appChange(app: PortalApp) {
    if (app.isExternal) {
      if (app.app === Application.DISCOVER_MANAGER) {
        const url = this.authService.getDiscoverAdminLaunchUrl();
        return window.open(url, '_blank');
      } else if ([Application.TITLEWAVE, Application.FM].indexOf(app.app) >= 0) {
        this.authService.launchToVendor(app.app as (Application.TITLEWAVE | Application.FM));
      } else if ([Application.MASTERLIBRARY_HELPDESK].indexOf(app.app) >= 0) {
          this.authService.launchToMLVendor(app.app as (Application.MASTERLIBRARY_HELPDESK));
      } else {
        return window.open(app.url, '_blank');
      }
    } else {
      this.hide = this.portalStateService.getActiveApp()?.app === app.app; // Hide if clicking on the app we're already on
      this.portalStateService.setActiveApp(app);
    }
    return undefined;

  }

  public getAppName(app: PortalApp) {
    return this.portalStateService.getAppName(app.app);
  }
}
